/*
 * Class used for utility methods
 */

export default class UTIL {
    // util for getting param sfrom url
    getParameterByName(nameIn, urlIn) {
        // eslint-disable-next-line no-unused-vars
        const $this = this;
        let url = urlIn;
        if (!url) {
            url = window.location.href;
        }
        const name = nameIn.replace(/[[\]]/g, '\\$&');
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}
